import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from './plugins/vuetify'
import { JazelAppConfig } from '@jazel/jazel-vuetify'
import App from './App.vue'
import router from './router'
import { useAccountSettingsStore } from './stores/accountSettings'
import { useProductSettingsStore } from './stores/productSettings'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)

// Install Jazel app config plugin BEFORE any store that calls useJazelAppConfig()
app.use(JazelAppConfig, {
  // inv_mgmt_system
  productId: 'ise',
  isEmbedded: document.getElementById('inventory-field-mapping')?.parentNode !== document.body,
  cdnUrl: import.meta.env.VITE_CDN_URL,
  jamsFrontendUrl: import.meta.env.VITE_JAMS_FRONTEND_URL,
  jamsBackendUrl: import.meta.env.VITE_JAMS_BACKEND_URL,
})

// E2E auth bypass: pre-seed account/session before JazelAppConfig plugin initializes
if (import.meta.env.VITE_E2E_AUTH === '1') {
  const accountSettings = useAccountSettingsStore()
  const productSettings = useProductSettingsStore()
  if (!accountSettings.sessionToken) {
    accountSettings.setSessionToken('e2e-token')
  }
  // Also store in localStorage for any consumers reading directly
  try {
    window.localStorage.setItem('sessionToken', 'e2e-token')
  } catch {}
  if (!accountSettings.accountId) {
    accountSettings.setAccountId('USFLSNS2763001')
  }
  accountSettings.setIsClientUser(false)
  // Skip onboarding
  // Also mark product settings as "loaded" so the root app can bootstrap.
  productSettings.setProductSettings({ isOnBoarding: false } as any)
}

app.mount('#ise')
